import { render, staticRenderFns } from "./BaseCountryFlagPhoneSearch.vue?vue&type=template&id=0857dfeb"
import script from "./BaseCountryFlagPhoneSearch.vue?vue&type=script&lang=js"
export * from "./BaseCountryFlagPhoneSearch.vue?vue&type=script&lang=js"
import style0 from "./BaseCountryFlagPhoneSearch.vue?vue&type=style&index=0&id=0857dfeb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports